module.exports = __webpack_public_path__ + "img/List - Blue.81c11c0b.svg";